<template>
  <div class="info main_center">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
        <el-button @click="revokeById()" plain size="small" type="primary" v-if="form.id && hasBtnPermission('btn_lawsRegulations_revoke') && form.submitFlag == 1 && form.canModify">撤销 </el-button>
      </div>
    </div>
    <div class="right-content clearfix busWinessRight" style="top: 60px">
      <el-card class="box-card">
        <el-form :model="form" label-width="220px" ref="form"
          style="position: relative; margin-bottom: 24px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="标题：" size="small" prop="title">
                {{form.title}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="文号：" prop="documentNumber" size="small">
                {{form.documentNumber}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发布年度：" prop="publishAnnual" size="small">
                {{form.publishAnnual}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传人：" prop="uploadUser" size="small">
                {{form.uploadUser}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :key="index" :span="24" v-for="(item, index) in form.fileList">
              <el-form-item :label="item.fileTypeName ? item.fileTypeName + '：' : '附件：'"
                :prop="'attachments' + item.fileType" size="small">
                <affix-msg :showDetail="true" :docItem.sync="item" :docName.sync="item.name" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import {getPortalPoliciesRegulationDetail, revokePortalPoliciesRegulationData} from "@/server/mainCredit.js";
import { mapState } from "vuex";
import affixMsg from "@/components/affixMsg";
export default {
  components: {
    affixMsg,
  },
  data() {
    return {
      form: {
        id: "",
        title: "",
        content: "",
        documentNumber:"",
        publishAnnual:"",
        attachments: [],
        fileList: [],
        submitFlag:"",
      },
      editFlag:true,
      rules: {
        title: [{required: true, message: "请输入标题",}],
        content: [{required: true, message: "请输入暂停原因",},],
        documentNumber: [{required: true, message: "请输入文号",},],
        publishAnnual: [{required: true, message: "请选择发布年度",},],
      },
    };
  },

  created() {
    this.$store.dispatch("dataDictionary/getLawsRegulationsAtt"); //获取投诉第一步
  },

  computed: {
    ...mapState({
      lawsRegulationsAtt: (state) => {
        return state.dataDictionary.lawsRegulationsAtt;
      },
    }),
  },

  watch: {
    lawsRegulationsAtt: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          if (this.$route.query.id) return;
          // 初始化附件数据
          let attachments = JSON.parse(
            JSON.stringify(this.lawsRegulationsAtt)
          );
          this.form.attachments = attachments;
        });
      },
    },
  },

  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      getPortalPoliciesRegulationDetail(this.$route.query.id).then((res) => {
        if (res.data.code == 1) {
          this.form = { ...this.form, ...res.data.data };
          this.getAttachmentsData();
        }
      });
    }
  },

  methods: {
    revokeById() {
      this.$confirm(`是否撤销这条数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        revokePortalPoliciesRegulationData(this.form.id).then((res) => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "撤销成功",
            });
            setTimeout(()=>{
              this.back()
            },2000)
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },
    getAttachmentsData() {
      this.$httpReq.get(`/attachment/getDataByCodeAndEid?categoryCode=portal_policies_regulation_att&entityId=${this.$route.query.id}`)
        .then(({ data }) => {
          if (data.code == 1) {
            this.form.attachments = data.data;
            for (let i = 0; i < data.data[0].attFiles.length; i += 1) {
              this.fileChange(
                {
                  ...data.data[0],
                  ...data.data[0].attFiles[i],
                },
                "add"
              );
            }
          }
        });
    },

    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: "lawsRegulationsList",
        query: {},
      });
    },

    fileChange(files, flag) {
      if (flag == "add") {
        this.form.fileList.push({
          hideLable: true,
          ...files,
          sysAttachmentDataId: (this.lawsRegulationsAtt[0] || {}).id,
        });
      } else if (flag == "del") {
        let dataList = this.form.fileList;
        if (files.id) {
          this.deleteFile(files.id);
        }
        let result = dataList.filter((item) => {
          if (item.uid && files.uid) {
            return item.uid != files.uid;
          }
          if (item.id && files.id) {
            return item.id != files.id;
          }
          return true;
        });
        this.form.fileList = result;
      }
    },

    deleteFile(id) {
      this.$httpReq({
        method: "post",
        url: `/attachment/delattachmentbyid`,
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code == 1) {
          this.$message.success("删除成功");
        }
      });
    },
  },
};
</script>
<style>
.w-e-toolbar {
  z-index: 101 !important;
}

.w-e-text-container {
  z-index: 100 !important;
}
</style>
